export default __webpack_public_path__ + "static/media/loadingdogs.081febf3.gif";